import Box from '@components/Box';
import Link from '@components/Link';
import { useStore } from '@hooks/useStore';
import { GLOBAL_STORE } from '@shared/constants';

import Alert from './Alert';

const LocalMarketWarning: IComponent = () => {
  const {
    stores: { changeStore },
  } = useStore();

  return (
    <Alert severity="warning" title="Local market">
      <Box>
        The local market is not supported in this view. Please select global
        market from the dropdown in the top right corner or{' '}
        <Link
          variant="inline"
          onClick={() => changeStore(GLOBAL_STORE.market.code)}
        >
          switch to Global
        </Link>{' '}
        directly.
      </Box>
    </Alert>
  );
};

export default LocalMarketWarning;
